import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import api from '~/services/api';
import { isArray } from 'lodash';

import { GFO, GPP } from '~/constants/perfil';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import ConfirmDialog from '../ConfirmDialog';
import { t } from '~/helpers';
import MyForm from './form';
const formRef = createRef();


class Detalhe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openConfirmarDialog: false,
      openRecusarDialog: false,
      params: {},
    };
  }

  // Toggle modal
  async handleToggleModal(params = {}) {
    this.setState((prevState) => ({
      open: !prevState.open,
      params,
    }));
  }

  // Close modal
  async handleCloseModal() {
    //this.setState({ openConfirmDialog: false });
    await this.setState({ open: false });
  }

  
  render() {
    const { open, params } = this.state;

    const { profile } = this.props.user;

    return (
      <>
        <Dialog
          open={open}
          maxWidth={'lg'}
          onClose={() => this.handleCloseModal()}
        //fullScreen={window.innerWidth <= 450}
        >
          <DialogTitle>
            {`${params.desc_status_pendencia}`}
          </DialogTitle>
          <DialogContent>
            <MyForm
              data={params}
              reference={formRef}
              close={() => {
                this.handleCloseModal();
                this.props.update();
              }}
            />
          </DialogContent>
          <DialogActions>

            <Button
              startIcon={<Close />}
              color="secondary"
              variant="outlined"
              onClick={() => this.handleCloseModal()}
            >
              {t('s.geral.botaocancelar')}
            </Button>
          </DialogActions>
        </Dialog>
       
      </>
    );
  }
}

const mapStateToProps = store => ({
  user: store.user
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(Detalhe);